// Update this URL whenever your webinar link changes
export const WEBINAR_CONFIG = {
  url: "/webinar",
  text: "Free Webinar"
};
